module.exports = "<div class=\"loader-container\">\r\n\t<h2>Cargando noticias</h2>\r\n\t<div class=\"sk-double-bounce\">\r\n\t\t<div class=\"double-bounce1\"></div>\r\n\t\t<div class=\"double-bounce2\"></div>\r\n\t</div>\r\n</div>\r\n<div class=\"news-list hidden\">\r\n\t\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/news-section/news-section.tpl.html
// module id = 122
// module chunks = 0